import React, { useContext, useEffect, useState } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import './ViewProjectHeader.css';
import ProjectAPIs from "../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { useNavigate, useParams } from "react-router-dom";
import ApiResponseHandler from "../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { Form } from "react-bootstrap";
import { FetchProjectContext, ProjectDataContext } from "../ViewProject";
import { useToast } from "../../../../../../Contexts/ToastContext";

function ViewProjectHeader() {

    const { addToast } = useToast();
    const routeParams = useParams();
    const navigate = useNavigate();

    const projectData = useContext(ProjectDataContext);
    const getProjectInformation = useContext(FetchProjectContext);

    const formatDateForInput = (timestamp) => {
        if (!timestamp) return "";
        return new Date(timestamp).toISOString().split("T")[0];
    };

    const formatDateForAPI = (dateString) => {
        if (!dateString) return null;
        return new Date(dateString).toISOString();
    };

    const [sending, setSending] = useState(false);
    const [editing, setEditing] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    
    const [dateError, setDateError] = useState("");
    const [formData, setFormData] = useState({
        name: projectData.name,
        cis_id: projectData.cis_id,
        start_date: formatDateForInput(projectData.start_date),
        end_date: formatDateForInput(projectData.end_date),
        completed: projectData.completed
    });

    

    // const getProjectInformation = (id) => {
    //     ProjectAPIs.GetProjectTitleInfo(id)
    //     .then((response) => {
    //         const data = response.data;

    //         setProjectData(data);
    //         setFormData({
    //             name: data.name,
    //             start_date: formatDateForInput(data.start_date),
    //             end_date: formatDateForInput(data.end_date),
    //             completed: data.completed
    //         });

    //         setLoading(false);
    //     })
    //     .catch((err) => {
    //         setLoading(false);
    //         ApiResponseHandler(err.response, navigate);
    //     });
    // }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleToggleCompleted = () => {
        if (sending) return; 
        setFormData(prev => ({
            ...prev,
            completed: !prev.completed
        }));
    };

    const handleSave = () => {
        if(dateError) return;

        setSending(true);
        const putJSON = {...projectData};
        putJSON.name = formData.name;
        putJSON.cis_id = formData.cis_id;
        putJSON.start_date = formatDateForAPI(formData.start_date);
        putJSON.end_date = formatDateForAPI(formData.end_date);
        putJSON.completed = formData.completed;

        console.log('PUT JSON: ', putJSON);

        ProjectAPIs.PutProjectTitleInfo(routeParams.ProjectID, putJSON)
        .then((response) => {
            if (response.status === 200) {
                setEditing(false);
                getProjectInformation(routeParams.ProjectID); // refresh data
                addToast({ message: "Details updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
        .finally(() => {
            setSending(false);
        })
    };

    const deleteProject = (projectID) => {
        setSending(true);
        ProjectAPIs.DeleteProject(projectID)
        .then((response) => {
            if (response.status === 200) {
                addToast({ message: "Project deleted successfully!", variant: "success", autoHide: true });
                navigate('/project');
            }
        })
        .catch((err) => {
            setSending(false);
            ApiResponseHandler(err.response, navigate);
        })
        .finally(() => {
            setSending(false);
        })
    };

    const handleDelete = () => {
        if (window.confirm('Are you sure you want to delete this project? This cannot be undone.')) {
            deleteProject(routeParams.ProjectID);
        }
    };

    useEffect(() => {
        getProjectInformation(routeParams.ProjectID);
    }, [routeParams.ProjectID]);

    useEffect(() => {
        setFormData({
            name: projectData.name,
            cis_id: projectData.cis_id,
            start_date: formatDateForInput(projectData.start_date),
            end_date: formatDateForInput(projectData.end_date),
            completed: projectData.completed
        })
    }, [projectData]);

    useEffect(() => {
        // validate dates whenever they change
        if (!formData.start_date || !formData.end_date) {
            setDateError("");
            return;
        }

        const start = new Date(formData.start_date);
        const end = new Date(formData.end_date);

        if (start > end) {
            setDateError("Start date cannot be after End date.");
        } else {
            setDateError("");
        }
    }, [formData.start_date, formData.end_date]);

    useEffect(() => {
        let ticking = false;

        const TOP_OFFSET = 10; // when to reset (near top)
        const SHRINK_OFFSET = 150; // when to shrink

        const updateScrollState = () => {
            const scrollY = window.scrollY;

            if (scrollY > SHRINK_OFFSET) {
                setIsScrolled(true); // shrink once
            } else if (scrollY < TOP_OFFSET) {
                setIsScrolled(false); // only expand at top
            }

            ticking = false;
        };

        const handleScroll = () => {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(updateScrollState);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

   

    return (
        <div className="project-header">

            {/* LEFT SIDE */}
            <div className={`project-header-left`}>

                {editing ? (
                    <>
                        <Form.Control
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="project-title-input editable-field"
                            disabled={sending}
                            
                        />
                    </>
                ) : (
                    <h2 className="project-title">{projectData.name}</h2>
                )}

                <div className={`project-meta ${isScrolled ? 'shrink' : ''}`}>

                    {editing ? 
                    <div className="meta-item">
                                <span className="label">CIS ID:</span>
                                <Form.Control
                                    name="cis_id"
                                    value={formData.cis_id}
                                    onChange={handleChange}
                                    disabled={sending}
                                    className="editable-field"
                                    size="sm"
                                />
                            </div>
                        :

                    <div className="meta-item">
                        <span className="label">CIS ID:</span>
                        <span>{projectData.cis_id}</span>
                    </div>
                    }

                    {editing ? (
                        <>
                            <div className="meta-item">
                                <span className="label">Start:</span>
                                <Form.Control
                                    type="date"
                                    name="start_date"
                                    value={formData.start_date}
                                    onChange={handleChange}
                                    disabled={sending}
                                    className="editable-field"
                                    size="sm"
                                />
                            </div>

                            <div className="meta-item">
                                <span className="label">End:</span>
                                <Form.Control
                                    type="date"
                                    name="end_date"
                                    value={formData.end_date}
                                    onChange={handleChange}
                                    disabled={sending}
                                    className="editable-field"
                                    size="sm"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="meta-item">
                                <span className="label">Start:</span>
                                <span>{formatDateForInput(projectData.start_date)}</span>
                            </div>

                            <div className="meta-item">
                                <span className="label">End:</span>
                                <span>{formatDateForInput(projectData.end_date)}</span>
                            </div>
                        </>
                    )}

                    <div className="meta-item">
                        {editing ? (
                            <span 
                                className={`status-badge editable ${formData.completed ? 'complete' : 'active'}`}
                                onClick={handleToggleCompleted}
                            >
                                {formData.completed ? "Completed ✓" : "Mark Complete"}
                            </span>
                        ) : (
                            <span className={`status-badge ${projectData.completed ? 'complete' : 'active'}`}>
                                {projectData.completed ? "Completed" : "Active"}
                            </span>
                        )}
                    </div>
                        
                    {(dateError && editing) && <div className="date-error">{dateError}</div>}
                </div>
            </div>

            {/* RIGHT SIDE ACTIONS */}
            <div className={`project-header-actions ${isScrolled ? 'shrink' : ''}`}>

                {editing ? (
                    <>
                        <button disabled={sending || dateError} className="save-btn" onClick={handleSave}>{sending ? 'Saving' : 'Save'}</button>
                        <button disabled={sending} className="cancel-btn" onClick={() => setEditing(false)}>Cancel</button>
                    </>
                ) : (
                    <>
                        <button disabled={sending} className="edit-btn" onClick={() => setEditing(true)}>
                            <MdEdit /> Edit
                        </button>

                        <button disabled={sending} className="delete-btn" onClick={handleDelete}>
                            <MdDelete /> {sending ? 'Deleting...' : 'Delete'}
                        </button>
                    </>
                )}

            </div>
        </div>
    );
}

export default ViewProjectHeader;